import { Eyebrow, Reveal } from "@/components/ui-bits";

const EQUIPMENT = [
  {
    number: "01",
    title: "53' TRACTOR-TRAILER",
    desc: "Full-size dry van transportation for commercial freight, full loads and partial shipments.",
    details: ["53 FT DRY VAN", "TRACTOR + TRAILER", "COMMERCIAL FREIGHT", "FTL & PARTIAL LOADS"],
    src: "/assets/tractor-trailer-53.webp",
    alt: "A 53-foot tractor-trailer with dry van at an Ontario warehouse loading dock",
    caption: "COMMERCIAL / FTL / PARTIAL LOADS",
    testid: "equipment-card-1",
  },
  {
    number: "02",
    title: "STRAIGHT TRUCK WITH TAILGATE",
    desc: "Straight-truck transportation with hydraulic liftgate capability for commercial freight and delivery requirements.",
    details: ["5-TON STRAIGHT TRUCK", "HYDRAULIC LIFTGATE", "COMMERCIAL FREIGHT", "DELIVERY SUPPORT"],
    src: "/assets/straight-truck-freightliner2.webp",
    alt: "A 30 NORTH conventional-cab straight truck with hydraulic tailgate at a commercial area in the GTA",
    caption: "HYDRAULIC LIFTGATE / DELIVERY SUPPORT",
    testid: "equipment-card-2",
  },
  {
    number: "03",
    title: "SPRINTER VAN",
    desc: "Agile transportation for smaller, urgent and time-sensitive shipments.",
    details: ["SPRINTER VAN", "EXPEDITED FREIGHT", "TIME-SENSITIVE SHIPMENTS", "DIRECT TRANSPORTATION"],
    src: "/assets/sprinter-downtown.webp",
    alt: "A 30 NORTH branded Sprinter van on a downtown Toronto street",
    caption: "EXPEDITED / TIME-SENSITIVE",
    testid: "equipment-card-3",
  },
];

const Equipment = () => {
  return (
    <section data-testid="equipment-section" aria-labelledby="equipment-heading" className="bg-[#f7f8f9] py-16 sm:py-20 lg:py-24">
      <div className="container-30">
        <Reveal className="max-w-3xl">
          <Eyebrow>Transportation Options</Eyebrow>
          <h2
            id="equipment-heading"
            data-testid="equipment-headline"
            className="mt-6 text-3xl font-extrabold leading-[1.08] tracking-tight text-[#191c1e] sm:text-4xl"
          >
            CAPACITY FOR DIFFERENT FREIGHT REQUIREMENTS.
          </h2>
          <p className="mt-6 text-base leading-relaxed text-[#5f666d] sm:text-lg">
            Different shipments require different transportation solutions. 30 NORTH can coordinate the appropriate
            transportation option based on your freight, timing, handling and delivery requirements.
          </p>
        </Reveal>

        <div className="mt-12 grid gap-5 md:grid-cols-2 lg:mt-14 lg:grid-cols-3" data-testid="equipment-grid">
          {EQUIPMENT.map((item, i) => (
            <Reveal key={item.number} delay={i * 0.08} className="h-full">
              <article
                data-testid={item.testid}
                className="flex h-full flex-col border border-[#e5e7eb] bg-white transition-all duration-300 hover:-translate-y-1 hover:border-[#191c1e] hover:shadow-[0_20px_40px_-24px_rgba(25,28,30,0.3)]"
              >
                <figure className="relative aspect-[3/2] border-b border-[#e5e7eb]">
                  <img
                    src={item.src}
                    alt={item.alt}
                    data-testid={`${item.testid}-image`}
                    className="absolute inset-0 h-full w-full object-cover"
                    loading="lazy"
                  />
                  <figcaption className="absolute bottom-0 left-0 max-w-full bg-[#191c1e] px-4 py-2 text-[10px] font-bold leading-relaxed tracking-[0.14em] text-white sm:text-[11px]">
                    {item.caption}
                  </figcaption>
                </figure>
                <div className="flex flex-1 flex-col p-6 lg:p-7">
                  <div className="flex items-center gap-4">
                    <span className="font-display text-2xl font-extrabold text-[#ff6a00]">{item.number}</span>
                    <span className="block h-px flex-1 bg-[#e5e7eb]" aria-hidden="true" />
                  </div>
                  <h3 className="mt-4 font-display text-xl font-bold tracking-tight text-[#191c1e]">{item.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-[#5f666d]">{item.desc}</p>
                  <ul className="mt-5 grid gap-x-4 gap-y-2.5" data-testid={`${item.testid}-details`}>
                    {item.details.map((d) => (
                      <li key={d} className="flex items-center gap-3">
                        <span className="block h-1.5 w-1.5 shrink-0 bg-[#ff6a00]" aria-hidden="true" />
                        <span className="text-[12px] font-bold tracking-[0.1em] text-[#191c1e]">{d}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Equipment;
